<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="shipment-search-section"
        id="shipment-search-section"
      >
        <el-form
          id="shipment-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.outboundDateFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.outboundDateFrom"
                  format="MM/dd/yyyy"
                  type="date"
                  id="searchForm-outboundDateFrom"
                  ref="filter-outboundDateFrom"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.outboundDateTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.outboundDateTo"
                  format="MM/dd/yyyy"
                  type="date"
                  clearable
                  id="searchForm-outboundDateTo"
                  ref="filter-outboundDateTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.status')">
                <el-select
                  v-model="searchForm.status"
                  id="searchForm-status"
                  ref="filter-status"
                  @change="handleSearch">
                  <el-option
                    v-for="option in shipmentStatusOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.shipper')">
                <autocomplete
                  :model.sync="searchForm.shipperAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlShippers"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  :includeInactive="true"
                  labelField="name"
                  valueField="id"
                  ref="filter-shipperAccountId"
                  id="searchForm-shipperAccountId"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.consignee')">
                <autocomplete
                  :model.sync="searchForm.consigneeAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlConsignee"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  :includeInactive="true"
                  labelField="name"
                  valueField="id"
                  ref="filter-consigneeAccountId"
                  id="searchForm-consigneeAccountId"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.billTo')">
                <autocomplete
                  :model.sync="searchForm.billToAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlBillTo"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  :includeInactive="true"
                  labelField="name"
                  valueField="id"
                  ref="filter-billToAccountId"
                  id="searchForm-billToAccountId"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.shipmentNumber')">
                <el-input
                  v-model="searchForm.shipmentNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-shipmentNumber"
                  id="searchForm-shipmentNumber"></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.receivingWarehouse')">
                <outbound-warehouse-select v-model="searchForm.receivingWarehouseId" @change="handleSearch" :includeOptionAll="true" />
              </el-form-item>
             </el-col>
             <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.outboundWarehouse')">
                <outbound-warehouse-select v-model="searchForm.outboundWarehouseId" @change="handleSearch" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.bolNumber')">
                <el-input
                        v-model="searchForm.bolNumber"
                        v-alphanumeric-validation
                        maxlength="20"
                        clearable
                        @clear="handleSearch"
                        v-on:keyup.enter.native="handleSearch"
                        class="inline-input"
                        ref="filter-bolNumber"
                        id="searchForm-bolNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.loadNumber')">
                 <el-input
                  v-model="searchForm.loadNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-loadNumber"
                  id="searchForm-loadNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.invoiceNumberShort')">
                 <el-input
                  v-model="searchForm.invoiceNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-invoiceNumber"
                  id="searchForm-invoiceNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('common.features')">
                <el-select
                  v-model="featuresSelected"
                  multiple
                  collapse-tags
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in features"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.manualChanges')">
                <el-select
                        v-model="searchForm.manualChanges"
                        id="searchForm-status"
                        ref="filter-status"
                        @change="handleSearch">
                  <el-option
                          v-for="option in shipmentManualChangesOptions"
                          :key="option.value"
                          :label="option.label"
                          :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.credited')">
                <el-select v-model="searchForm.credited" @change="handleSearch">
                  <el-option
                      v-for="item in allYesNoOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- Row with just search button -->
          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="shipment-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Autocomplete from '@/components/Autocomplete';
import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import { SHIPMENT_SEARCH, SHIPMENT_SET_CONSIGNEE_ACCOUNT_NAME_FILTER_LABEL } from '@/store/actions';

const filterConsigneeAccountIdRef = 'filter-consigneeAccountId';

export default {
  name: 'shipmentSearchSection',
  components: { Autocomplete, OutboundWarehouseSelect },
  computed: {
    ...mapGetters(['shipment']),
    features() {
      return constants.FILTER_FEATURES;
    },
    allYesNoOptions() {
      return [
        {
          value: null,
          label: 'All'
        },
        {
          value: constants.STATUS_BOOLEAN.yes.value,
          label: constants.STATUS_BOOLEAN.yes.label
        },
        {
          value: constants.STATUS_BOOLEAN.no.value,
          label: constants.STATUS_BOOLEAN.no.label
        }
      ];
    }
  },
  data() {
    return {
      activeCollapsibleName: ['shipment-search-section'],
      isOpen: ['shipment-search-section'],
      searchForm: {
        outboundDateFrom: new Date(),
        outboundDateTo: null,
        status: constants.SHIPMENT.STATUS[0].value,
        manualChanges: constants.SHIPMENT.MANUAL_CHANGES[0].value,
        shipperAccountId: null,
        consigneeAccountId: null,
        billToAccountId: null,
        shipmentNumber: null,
        bolNumber: null,
        loadNumber: null,
        invoiceNumber: null,
        outboundWarehouseId: null,
        receivingWarehouseId: null,
        credited: null
      },
      featuresSelected: [],
      shipmentStatusOptions: constants.SHIPMENT.STATUS,
      shipmentManualChangesOptions: constants.SHIPMENT.MANUAL_CHANGES,
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      urlShippers: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      urlBillTo: apiConstants.END_POINTS.ACCOUNTS.BILL_TO
    };
  },
  watch: {
    'searchForm.outboundDateFrom': function updateTo(newVal) {
      // to work with changes in someOtherProp
      const newOutboundDateFrom = moment(newVal);
      if (newOutboundDateFrom.isAfter(moment(this.searchForm.outboundDateTo))) {
        this.searchForm.outboundDateTo = newVal;
      }
    },
    'searchForm.outboundDateTo': function updateFrom(newVal) {
      const newOutboundDateTo = moment(newVal);
      if (newOutboundDateTo.isBefore(moment(this.searchForm.outboundDateFrom))) {
        this.searchForm.outboundDateFrom = newVal;
      }
    }
  },
  methods: {
    handleSearch() {
      const featureFields = {};
      for (const feature of this.features) {
        featureFields[feature.value] = this.featuresSelected.some(featureSelected => feature.value === featureSelected);
      }
      this.$store.dispatch(SHIPMENT_SEARCH, { ...this.searchForm, ...featureFields });
      this.$store.dispatch(SHIPMENT_SET_CONSIGNEE_ACCOUNT_NAME_FILTER_LABEL, this.$refs[filterConsigneeAccountIdRef].getLocalModel());
    }
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.outboundDateFrom) {
        this.searchForm.outboundDateFrom = moment(this.$route.query.outboundDateFrom).toDate();
      }
      if (this.$route.query.outboundDateTo) {
        this.searchForm.outboundDateTo = moment(this.$route.query.outboundDateTo).toDate();
      }
      if (this.$route.query.consigneeAccountId && this.$route.query.consigneeAccountName) {
        this.searchForm.consigneeAccountId = this.$route.query.consigneeAccountId;
        this.$nextTick(() => {
          this.$refs[filterConsigneeAccountIdRef].setLocalModel(this.$route.query.consigneeAccountName);
          this.$store.dispatch(SHIPMENT_SET_CONSIGNEE_ACCOUNT_NAME_FILTER_LABEL, this.$refs[filterConsigneeAccountIdRef].getLocalModel());
        });
      }
      if (this.$route.query.invoiceNumber) {
        this.searchForm.invoiceNumber = this.$route.query.invoiceNumber;
      }
    }
    this.handleSearch();
  }
};
</script>
